var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var formGroup = require('../../components/formGroup');
var serviceTaxonomy = require('../../service/serviceTaxonomy');
var serviceClassSelect = require('../../service/components/serviceClassSelect');
var serviceModel = require('../../service/models/service');
var ontologyPorts = require('../../../../../models/equipment/ontologyPorts');

var editClassPortModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


editClassPortModal.editDialogue = function (portDefinition, portCenterSelected, options) {
  editClassPortModal.portDefinition = portDefinition;
  editClassPortModal.portCenterSelected = portCenterSelected;
  editClassPortModal.modifiedPortDefinition = prop(buildClassPortDefinition(portDefinition));
  editClassPortModal.errors = [];

  var submit = async function () {
    await serviceModel.getClassTree().catch(function () {
      return null;
    });
    editClassPortModal.errors = [];
    var nextPortDefinition = normalizeModifiedPortDefinition();
    editClassPortModal.errors = ontologyPorts.validatePortDefinitions([nextPortDefinition]);
    if (editClassPortModal.errors.length > 0) {
      m.redraw();
      return Promise.resolve(false);
    }
    Object.assign(editClassPortModal.portDefinition, nextPortDefinition);
    if (options && options.submitCallback) {
      await options.submitCallback(editClassPortModal.portDefinition);
    }
    modal.vm.close();
  };

  serviceModel.getClassTree().then(function () {
    normalizeModifiedPortDefinition();
    m.redraw();
  }).catch(function () {
    return null;
  });

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(`Edit ${portDefinition.name}: `)
  modal.vm.body = editClassPortModal.view,
  modal.vm.buttons([
    {
      label: "Submit",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


editClassPortModal.view = function () {
  normalizeModifiedPortDefinition();
  return m('form', {role:'form'}, [
    editClassPortModal.errorView(),
    m(formGroup, [
      m('label', 'Name'),
      m('input.form-control', {
        type:'text', 
        oninput: function(ev) { editClassPortModal.modifiedPortDefinition().name = ev.target.value; },
        value: editClassPortModal.modifiedPortDefinition().name,
      })
    ]),
    m(formGroup, [
      m('label', 'External Position'),
      m('select', {
        onchange: function(ev) { setPortPosition(ev.target.value); },
        value: editClassPortModal.modifiedPortDefinition().position
      },[
          m('option', {value: 'center', disabled: isCenterPositionDisabled()}, 'Center'),
          m('option', {value: 'left'}, 'Left'),
          m('option', {value: 'right'}, 'Right'),
          m('option', {value: 'top'}, 'Top'),
          m('option', {value: 'bottom'}, 'Bottom')
      ])
    ]),
    m(formGroup, [
      m('label', 'Type'),
      m('select', {
        onchange: function(ev) { editClassPortModal.modifiedPortDefinition().type = ev.target.value; },
        value: ontologyPorts.normalizePortType(
          editClassPortModal.modifiedPortDefinition().position,
          editClassPortModal.modifiedPortDefinition().type
        ),
      },[
        editClassPortModal.modifiedPortDefinition().position == 'center' ? 
          m('option', {value: 'bidirectional'}, 'Bidirectional')
        : 
          [
            m('option', {value: 'input'}, 'Input'),
            m('option', {value: 'output'}, 'Output')

          ]
      ])
    ]),
    m(formGroup, [
      m('label', 'Arrow Direction'),
      m('select', {
        onchange: function(ev) { editClassPortModal.modifiedPortDefinition().direction = ev.target.value; },
        value: editClassPortModal.modifiedPortDefinition().direction,
      },[
        m('option', {value: 'right'}, 'Right'),
        m('option', {value: 'left'}, 'Left')
      ])
    ]),
    m(formGroup, [
      m('label', 'Arrow Connector'),
      m('select', {
        onchange: function(ev) { editClassPortModal.modifiedPortDefinition().connector = ev.target.value; },
        value: editClassPortModal.modifiedPortDefinition().connector,
      },[
        m('option', {value: 'head'}, 'Head'),
        m('option', {value: 'tail'}, 'Tail')
      ])
    ]),
    m(formGroup, [
      m('label', 'Service'),
      m(serviceClassSelect, {
        onchange: function(value) { serviceTaxonomy.setServiceClass(editClassPortModal.modifiedPortDefinition(), value); },
        value: serviceTaxonomy.getServiceClass(editClassPortModal.modifiedPortDefinition())
      })
    ])
  ])

}

function findFirstServiceClass(categories) {
  for (let idx = 0; idx < (categories || []).length; idx++) {
    let category = categories[idx];
    if (!category) continue;
    if (category.name && category.name !== 'Overview') return category.name;
    let childClass = findFirstServiceClass(category.children || []);
    if (childClass) return childClass;
  }
  return '';
}

function getDefaultServiceClass() {
  return findFirstServiceClass((serviceModel.measurableClassTree || {}).categories || []);
}

function buildClassPortDefinition(portDefinition) {
  return ontologyPorts.buildPortDefinition(portDefinition, {
    fallbackServiceClass: getDefaultServiceClass()
  });
}

function normalizeModifiedPortDefinition() {
  var normalizedPortDefinition = buildClassPortDefinition(editClassPortModal.modifiedPortDefinition());
  editClassPortModal.modifiedPortDefinition(normalizedPortDefinition);
  return normalizedPortDefinition;
}

function setPortPosition(position) {
  var portDefinition = editClassPortModal.modifiedPortDefinition();
  portDefinition.position = position;
  portDefinition.type = ontologyPorts.normalizePortType(position, portDefinition.type);
}

function isCenterPositionDisabled() {
  return editClassPortModal.portCenterSelected &&
    editClassPortModal.portCenterSelected() &&
    editClassPortModal.portDefinition &&
    editClassPortModal.portDefinition.position !== 'center';
}

editClassPortModal._private = {
  buildClassPortDefinition,
  findFirstServiceClass,
  getDefaultServiceClass,
  isCenterPositionDisabled,
  normalizeModifiedPortDefinition,
  setPortPosition
};

module.exports = editClassPortModal;
